<template>
    <div class="sale-weekly-wrappper">
        <div class="top-wrapper">
            <div class="select-wrapper">
                <!-- <span>{{ StationName }}</span>
                <i class="iconfont iconxiala"></i> -->
                <div class="select-item">
                    <div @click="startTimePicker = true">
                        <span>{{ startTimeValue }}</span>
                        <i class="iconfont iconxiala"></i>
                    </div>
                    <p>—</p>
                    <div @click="endTimePicker = true">
                        <span>{{ endTimeValue }}</span>
                        <i class="iconfont iconxiala"></i>
                    </div>
                </div>
                <div class="select-item" @click="showPicker = true">
                    <span>{{ StationName }}</span>
                    <i class="iconfont iconxiala"></i>
                </div>
            </div>
            <div class="statistics-head">
                <div class="month-count">
                    <span>{{ statistics.fhfl || 0 }}</span>
                    <p>销量（方）</p>
                </div>
                <div class="year-count">
                    <span>{{ statistics.je || 0 }}</span>
                    <p>金额（万元）</p>
                </div>
            </div>
        </div>
        <div class="chart-wrapper">
            <p>按销量</p>
            <div id="myChart1" class="my-chart"></div>
        </div>
        <div class="bottom-wrapper">
            <p>按金额</p>
            <div id="myChart2" class="my-chart"></div>
        </div>
        <van-popup v-model="showPicker" position="bottom">
            <van-picker
                show-toolbar
                :columns="columns"
                @cancel="showPicker = false"
                @confirm="onConfirm"
            ></van-picker>
        </van-popup>
        <!-- 开始时间 -->
        <van-popup v-model="startTimePicker" position="bottom" :overlay="true">
            <van-datetime-picker
                v-model="startCurrentDate"
                type="date"
                title="选择年月日"
                @confirm="startConfirmData"
                @cancel="startTimePicker = false"
            ></van-datetime-picker>
        </van-popup>
        <!-- 结束时间 -->
        <van-popup v-model="endTimePicker" position="bottom" :overlay="true">
            <van-datetime-picker
                v-model="endCurrentDate"
                type="date"
                title="选择年月日"
                @confirm="endConfirmData"
                @cancel="endTimePicker = false"
            ></van-datetime-picker>
        </van-popup>
    </div>
</template>

<script>
import bg_orange from '../../../assets/images/home/bg_orange.png';
import { Toast } from 'vant';
export default {
    data() {
        return {
            startTimeValue: '', // 开始时间text
            endTimeValue: '', // 结束时间text
            startTimePicker: false, // 开始时间弹出层
            endTimePicker: false, // 结束时间弹出层
            startCurrentDate: new Date(new Date().getTime() - 3600 * 1000 * 24 * 6), // 开始时间默认日期
            endCurrentDate: new Date(), // 结束时间默认日期
            StationName: '',
            StationData: [
                {
                    station_id: '',
                    station_name: '全部',
                },
            ],

            showPicker: false,
            columns: [],
            ChartData: [],
            statistics: {},
        };
    },
    created() {
        this.startTimeValue = this.formatDate(this.startCurrentDate);
        this.endTimeValue = this.formatDate(this.endCurrentDate);
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            // 获取场站
            await this.getStationList();
            // 头部统计字段
            await this.getStatistics();
            // 获取页面数据图表
            await this.getStatisticsCharts();
        },
        // 获取企业下所有场站
        async getStationList() {
            let stationIds = this.$takeTokenParameters('StationIds');
            if (stationIds) {
                stationIds = stationIds.split(',');
                const stationNames = this.$takeTokenParameters('StationNames').split(',');
                const stationList = stationIds.map((id, index) => {
                    return {
                        station_id: id,
                        name: stationNames[index],
                    };
                });
                this.StationData.push(...stationList);
                this.columns = this.StationData.map(item => item.name);
                this.StationName = this.columns[0];
            }
        },
        getStatistics() {
            const row = this.StationData.filter(item => {
                return item.station_name === this.StationName;
            });
            this.$axios
                .get('/interfaceApi/report/tjfx/mzsj/xszb/tj?station_id='
                + row[0].station_id + '&start_time='
                + this.startTimeValue + '&end_time='
                + this.endTimeValue)
                .then(res => {
                    this.statistics = res;
                })
                .catch(error => {
                    Toast.fail('message:' + error.ErrorCode.Message + '');
                });
        },
        getStatisticsCharts() {
            const row = this.StationData.filter(item => {
                return item.station_name === this.StationName;
            });
            this.$axios
                .get('/interfaceApi/report/tjfx/mzsj/xszb/xlje?station_id='
                + row[0].station_id + '&start_time='
                + this.startTimeValue + '&end_time='
                + this.endTimeValue)
                .then(res => {
                    this.ChartData = res;
                    this.myChart1();
                    this.myChart2();
                })
                .catch(error => {
                    Toast.fail('message:' + error.ErrorCode.Message + '');
                });
        },
        startConfirmData(val) {
            this.startCurrentDate = val; // 开始时间默认日期
            this.endCurrentDate = new Date(val.getTime() + 3600 * 1000 * 24 * 6);// 结束时间默认日期

            this.startTimePicker = false;
            this.startTimeValue = this.formatDate(val);
            this.endTimeValue = this.formatDate(this.endCurrentDate);
            this.getStatistics();
            this.getStatisticsCharts();
        },
        endConfirmData(val) {
            this.startCurrentDate = new Date(val.getTime() - 3600 * 1000 * 24 * 6); // 开始时间默认日期
            this.endCurrentDate = val;// 结束时间默认日期

            this.endTimePicker = false;
            this.endTimeValue = this.formatDate(val);
            this.startTimeValue = this.formatDate(this.startCurrentDate);
            this.getStatistics();
            this.getStatisticsCharts();
        },
        onConfirm(val) {
            this.showPicker = false;
            this.StationName = val;
            this.getStatistics();
            this.getStatisticsCharts();
        },
        formatDate(date) {
            date = new Date(date);
            const y = date.getFullYear();
            let m = date.getMonth() + 1;
            let d = date.getDate();
            m = m < 10 ? '0' + m : m;
            d = d < 10 ? '0' + d : d;
            return y + '-' + m + '-' + d;
        },
        myChart1() {
            const myChart = this.$echarts.init(document.getElementById('myChart1'));
            const xdata = [];
            const data = [];
            this.ChartData.forEach(item => {
                xdata.push(item.name);
                data.push(item.fhfl);
            });
            const option = {
                grid: {
                    left: 40,
                    top: 40,
                    right: 0,
                    bottom: 20,
                },
                xAxis: {
                    data: xdata,
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#D7D7D7',
                            width: 1, // 这里是为了突出显示加上的
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#979EA7',
                            fontSize: 12,
                        },
                    },
                },
                yAxis: [{
                    splitNumber: 4,
                    name: '(方)',
                    nameTextStyle: {
                        align: 'right',
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#D7D7D7',
                            width: 1, // 这里是为了突出显示加上的
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#979EA7',
                            fontSize: 12,
                        },
                    },
                    splitArea: {
                        areaStyle: {
                            color: 'rgba(255,255,255,.5)',
                        },
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#ccc',
                            width: 1,
                            type: 'dashed',
                        },
                    },
                },
                ],
                series: [{
                    type: 'pictorialBar',
                    stack: '',
                    symbol: 'fixed',
                    symbolSize: [30, 10],
                    // symbolMargin: 10,
                    symbolRepeat: 'repeat',
                    // symbolBoundingData: 450,
                    label: {
                        show: true,
                        position: 'top',
                        distance: 0,
                        color: '#FA8B47',
                        fontWeight: 'bolder',
                        fontSize: 12,
                        formatter: '{c}',
                        align: 'center',
                        lineHeight: 22,
                        padding: [0, 10, 4, 10],
                        backgroundColor: {
                            image: bg_orange,
                        },
                    },
                    barWidth: 10,
                    itemStyle: {
                        normal: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0,
                                    color: 'rgba(239,171,84,1)', //  0%  处的颜色
                                },
                                {
                                    offset: 1,
                                    color: 'rgba(250,139,71,1)', //  100%  处的颜色
                                },
                                ],
                                global: false, //  缺省为  false
                            },
                        },
                        emphasis: {
                            opacity: 1,
                        },
                    },
                    data: data,
                    z: -10,
                }],
            };
            myChart.setOption(option);
        },
        myChart2() {
            const myChart = this.$echarts.init(document.getElementById('myChart2'));
            const xdata = [];
            const data = [];
            this.ChartData.forEach(item => {
                xdata.push(item.name);
                data.push(item.je);
            });
            const option = {
                grid: {
                    left: 35,
                    top: 40,
                    right: 10,
                    bottom: 20,
                },
                xAxis: {
                    data: xdata,
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#D7D7D7',
                            width: 1, // 这里是为了突出显示加上的
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#979EA7',
                            fontSize: 12,
                        },
                    },
                },
                yAxis: [{
                    splitNumber: 5,
                    name: '(万元)',
                    nameTextStyle: {
                        align: 'right',
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#D7D7D7',
                            width: 1, // 这里是为了突出显示加上的
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#979EA7',
                            fontSize: 12,
                        },
                    },
                    splitArea: {
                        areaStyle: {
                            color: 'rgba(255,255,255,.5)',
                        },
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#ccc',
                            width: 1,
                            type: 'dashed',
                        },
                    },
                },
                ],
                series: [{
                    name: '',
                    type: 'line',
                    label: {
                        show: true,
                        position: 'top',
                        distance: 0,
                        color: '#449FF3',
                        fontWeight: 'bolder',
                        fontSize: 12,
                        formatter: '{c}',
                        width: 18,
                        height: 22,
                        align: 'center',
                        lineHeight: 20,
                    },
                    lineStyle: {
                        normal: {
                            color: '#449FF3', // 线条颜色
                        },
                    },
                    itemStyle: {
                        color: '#fff',
                        borderColor: '#449FF3',
                        borderWidth: 1,
                    },
                    areaStyle: {
                        normal: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(68,159,243,1)',
                            },
                            {
                                offset: 1,
                                color: 'rgba(68,159,243,0.2)',
                            },
                            ], false),
                        },
                    },
                    data: data,
                    z: 10,
                }],
            };
            myChart.setOption(option);
        },
    },
};
</script>

<style lang="stylus">
    .sale-weekly-wrappper
        width 100%
        height 100%
        background #F0F0F0
        .top-wrapper
            background #ffffff
            padding 10rpx
            .select-wrapper
                height 45rpx
                box-shadow 0px 2px 8px 0px rgba(0, 0, 0, 0.16)
                border-radius 8px
                display flex
                .select-item
                    flex 1
                    text-align center
                    span
                        font-size 14rpx
                        font-weight 600
                        line-height 45rpx
                    i
                        color #979EA7
                    &:last-child
                        span
                            color #3495FB
                            padding-left 20rpx
                            border-left 2rpx solid #D7D7D7
                    &:first-child
                        flex 2
                        display flex
                        div
                            flex 1
                        p
                            line-height 45rpx
                            color #979EA7
                            font-weight 600
            .statistics-head
                background #ffffff
                display flex
                padding 10rpx
                margin-top 10rpx
                div
                    flex 1
                    text-align center
                    &.month-count
                        span
                            color #FA8436
                            font-size 16rpx
                    &.year-count
                        span
                            color #5588F1
                            fonts-size 16rpx
                    p
                        font-size 10rpx
                        color #666666
                        line-height 20rpx
        .chart-wrapper
            background #ffffff
            margin-top 15rpx
            padding 10rpx
            p
                font-size 16rpx
                color #333333
                font-weight 600
                margin-top 15rpx
            .my-chart
                height 240rpx
        .bottom-wrapper
            background #ffffff
            margin-top 15rpx
            padding 10rpx
            p
                font-size 16rpx
                color #333333
                font-weight 600
                // margin-top 15rpx
            .my-chart
                height 240rpx

</style>
